import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import ENDPOINT from '../../../globals/api-endpoint';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SignupForm = styled.form`
	text-align: left;
	margin: 0 auto;
	padding: 0 20px;
	max-width: 300px;
`;

const SignupFormContainer = styled.div`
	margin: 50px auto;
	text-align: center;
	padding : 20px;
	border: 1px solid ${props => props.theme.green};
	border-radius: 5px;
	max-width: 350px;
`;

const Input = styled.input`
	color : white;
	background: ${props => props.theme.purple};
	font-size : 16px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : center;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
	&:hover {
		background: white;
		color : ${props => props.theme.purple};
		cursor: pointer;
	}
`;

const H3 = styled.h3`
	margin-bottom: 10px;
`;

const WarningStyled = styled.p`
	color: red;
`;

const InputStyled =styled.input`
	font-size : 14px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : left;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
`;

const InputContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
`;

const Login = (props) => {
	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);

	const [newUser, setNewUser] = useState({
		email: '',
		password: '',
		name: '',
		about: '',
		headline: '',
		whatsapp: '',
		contact: '',
		portfolio: ''
	});

	const [isLoading, setIsLoading] = useState(null);
	const [isFailed, setIsFailed] = useState(null);

	const { auth } = useContext(AuthContext);

	const handleEmailChange = (newEmail) => {
		setNewUser((prevUser) => ({
			...prevUser,
			email: newEmail
		}));
	}

	const handlePassChange = (newPass) => {
		setNewUser((prevUser) => ({
			...prevUser,
			password: newPass
		}));
	}

	const handleNameChange = (newName) => {
		setNewUser((prevUser) => ({
			...prevUser,
			name: newName
		}));
	}

	const handleAboutChange = (newAbout) => {
		setNewUser((prevUser) => ({
			...prevUser,
			about: newAbout
		}));
	}

	const handleHeadlineChange = (newHead) => {
		setNewUser((prevUser) => ({
			...prevUser,
			headline: newHead
		}));
	}

	const handleWhatsappChange = (newWA) => {
		setNewUser((prevUser) => ({
			...prevUser,
			whatsapp: newWA
		}));
	}

	const handleContactChange = (newContact) => {
		setNewUser((prevUser) => ({
			...prevUser,
			contact: newContact
		}));
	}

	const handlePortfolioChange = (newPort) => {
		setNewUser((prevUser) => ({
			...prevUser,
			portfolio: newPort
		}));
	}

	const handleSignup = (e) => {
		window.scrollTo(0, 0)
		e.preventDefault();
		setIsLoading(true)
		fetch(ENDPOINT.USER_SIGNUP, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(newUser)
		})
		.then(res=> res.json())
		.then(res=> {
			if(res.message === 'User registered') {
				setIsFailed(false);
				setNewUser({
					email: '',
					password: '',
					name: '',
					about: '',
					headline: '',
					whatsapp: '',
					contact: '',
					portfolio: ''
				})
			} else {
				setIsFailed(true);
			}
		})
		.catch(err => console.log(err))
		.finally(res => {
			setIsLoading(false);
		})
	}

	const loading = 
		<div className="loading">
			<div className="sk-folding-cube">
			  <div className="sk-cube1 sk-cube"></div>
			  <div className="sk-cube2 sk-cube"></div>
			  <div className="sk-cube4 sk-cube"></div>
			  <div className="sk-cube3 sk-cube"></div>
			</div>
		</div>
	;

	const SignupFailed = () => {
		if (isFailed === true) {
			return <WarningStyled>Gagal mendaftar, periksa data yang anda masukkan</WarningStyled>
		} else if (isFailed === false) {
			return <p>Pendaftaran berhasil silahkan masuk untuk melanjutkan</p>
		} else {
			return null;
		}
	}

	if (auth.isAuth) {
		 return <Redirect to={'/beranda'} />
	}

	if (isLoading) {
		return loading;
	} else {
		return(
			<SignupFormContainer onSubmit={handleSignup}>
				<Helmet>
					<title>daftar ke bantuin</title>
				</Helmet>
				<H3>Daftar</H3>
				<SignupFailed />
				<SignupForm>
					<InputContainer>
						<label htmlFor="email">Email :</label>
						<InputStyled type="text" value={newUser.email} onChange={(e) => handleEmailChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="password">password :</label>
						<InputStyled type="password" value={newUser.password} onChange={(e) => handlePassChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="name">name :</label>
						<InputStyled type="text" value={newUser.name} onChange={(e) => handleNameChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="headline">Headline :</label>
						<InputStyled type="text" value={newUser.headline} onChange={(e) => handleHeadlineChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="whatsapp">Whatsapp :</label>
						<InputStyled type="text" value={newUser.whatsapp} onChange={(e) => handleWhatsappChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="contact">Contact :</label>
						<InputStyled type="text" value={newUser.contact} onChange={(e) => handleContactChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="portfolio">Link portfolio :</label>
						<InputStyled type="text" value={newUser.portfolio} onChange={(e) => handlePortfolioChange(e.target.value)}/>
					</InputContainer>
					<InputContainer>
						<label htmlFor="about">Tentang Saya :</label>
						<textarea name="about" cols="30" rows="5" value={newUser.about} onChange={(e) => handleAboutChange(e.target.value)}></textarea>
					</InputContainer>
					<Input type="submit" value="Daftar"/>
				</SignupForm>
				<NavLink to={'/login'}>Sudah punya akun? Login sekarang</NavLink>
			</SignupFormContainer>
		);
	}
}

export default Login;